import React from "react";

// set the defaults
const DatepickerAlertContext = React.createContext({
  language: "en",
  setLanguage: () => { }
});

export default DatepickerAlertContext;
